import dynamic from 'next/dynamic';
import { memo, useRef } from 'react';
import { useSelector } from 'react-redux';
import Alerts from '@/vdp/Alerts';
import { globalError } from '~/constants/errorBoundaryEvents';
import Sections from '~/constants/sections';
import { getIsWIPVehicle } from '~/selectors';
import {
  withErrorBoundary,
  ErrorBoundaryFallbackComponentProps
} from '~/utilities/ErrorBoundary';
import generateErrorLogger from '~/utilities/errorHandlers';
import { HeroContainer } from './Hero.styles';
import { HeroContextProvider } from './HeroContext';
import HeroData from './HeroData';
import Spinner from './Spinner';

const OnDemandHero = dynamic(
  () =>
    import(
      /* webpackChunkName: "OnDemandHero" */ '@/vdp/Reservable/OnDemandHero'
    )
);

function Hero() {
  const ref = useRef<HTMLDivElement>(null);
  const isWIPVehicle = useSelector(getIsWIPVehicle);

  return (
    <HeroContextProvider>
      <HeroData />
      <HeroContainer
        className={Sections.General}
        data-nav-section={Sections.Hero}
        data-qa="hero-container"
        id={Sections.Hero}
        ref={ref}
      >
        <Alerts />
        {isWIPVehicle ? <OnDemandHero /> : <Spinner />}
      </HeroContainer>
    </HeroContextProvider>
  );
}

const FallbackComponent = (_: ErrorBoundaryFallbackComponentProps) => null;

export default withErrorBoundary(
  memo(Hero),
  FallbackComponent,
  generateErrorLogger(globalError),
  Sections.Hero
);
